/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React, {Component} from 'react';
import FrontMatter from './ComponentPageComponents/FrontMatterComponent/FrontMatter';
import ChapterWrapper from './ComponentPageComponents/ChapterWrapper';
import AddContentComponent from './ComponentPageComponents/ChapterComponents/AddContentComponent';
import ComponentDRV from './ComponentPageComponents/ComponentDRV';
import ComponentOM from './ComponentPageComponents/ComponentOM';
import {LoaderPage} from "./ComponentPageComponents/LoaderPage";
import urlHelper from "../../../_helpers/url.format.server.helper";
import config from "../../../config";
import AxiosClient from "../../../_helpers/http.helper";
import { PERMISSIONS } from "../../constants/constants";

export default class BookComponents extends Component {

    constructor(props) {
        super(props);
        this.state = {
            AddContentVisibility: false,
            selectedChapterId: '',
            selectedChapterResources: [],
            rebuildBookComplete: false,
        };
    }

    addToCollection = (resourcesIds, insertPosition) => {
        const payload = {
            insertAfter: insertPosition,
            resourceIds: resourcesIds,
            currency: this.props.activeCollection.geo.code,
            priceType: this.props.activeCollection.collectionType
        };
        this.props.addResourcesToCollection(this.props.activeCollection.collectionId, this.state.selectedChapterId, payload);
        setTimeout(()=>{this.hideAddContentComponent();},2000);
    };

    showAddContentComponent = (chapterId, selectedChapterResources) => {
        this.setState({AddContentVisibility: true, selectedChapterId: chapterId, selectedChapterResources: selectedChapterResources});

    };
    hideAddContentComponent = () => {
        this.setState({AddContentVisibility: false, selectedChapterId: '', selectedChapterResources: []});
    };
    componentDidMount() {
        this.props.guardDirtySetActive(false);
        this.getBookBuildDetails(this.props.match.params.collId);
    }
    getBookBuildDetails(collectionId) {
        const url = urlHelper.formatUrl(
            config.collectionService.baseUrl,
            config.collectionService.routes.getBookBuildContent,
            {
                collectionId: collectionId
            }
        );
        AxiosClient.get(url)
            .then(response => {
                this.setState({ rebuildBookComplete: response.data.rebuildBookComplete });
                if(response.data.rebuildBookComplete){
                    this.props.getDRVS(this.props.match.params.collId);
                }
            })
            .catch(error => {
                console.log("Error", error);
            });
    }

    render() {
        const activeCollection = this.props.collection;
        const loadCollection = this.props.loadInitialData;
        const {collectionChapterResources, drvs , printAdminComponent} = this.props;

        return (
            this.state.rebuildBookComplete ?
                <div>
                    <div><FrontMatter pdfs={this.props.options.pdfs} collectionId={this.props.options.collectionId} getPdfLinks={this.props.options.getPdfLinks} viewOnlyFrontmatter={this.props.permissions.includes(PERMISSIONS.view_only_add_frontmatter)} ></FrontMatter></div>
                    {activeCollection && <ChapterWrapper
                        activeCollection={activeCollection}
                        chapterResources={collectionChapterResources}
                        loadCollection={loadCollection}
                        showAddContentComponent={this.showAddContentComponent}
                        drvs={drvs}
                        printAdminComponent={printAdminComponent}
                        permissions={this.props.permissions}
                    />}

                    {
                        activeCollection && <ComponentDRV
                            activeCollection={activeCollection}
                            drvs={drvs}
                        />
                    }

                    {
                        activeCollection && <ComponentOM
                            resourceIds={activeCollection.resourceIds} collectionId={activeCollection.collectionId} permissions={this.props.permissions}
                        />
                    }


                    {this.state.AddContentVisibility && <AddContentComponent
                        selectedChapterResources={this.state.selectedChapterResources}
                        // addToCollection={this.addToCollection}
                        // resetSearchData={this.props.resetSearchData}
                        // resourceSearchResult={this.props.resourceSearchResult}
                        closeModal={this.hideAddContentComponent}
                        activeCollection={this.props.collection}
                        loadCollection={this.props.loadInitialData}
                    // cbeContentSearch={this.props.cbeContentSearch}
                    // fetchPDFURL={this.props.fetchPDFURL}
                    //resetPDFURL={this.props.resetPDFURL}
                    />
                    }
                </div> : <LoaderPage/>
        );
    }

}


// WEBPACK FOOTER //
// ./src/components/pages/BookContainer/BookComponents.js